import React from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { SortOrder } from '@/api/bol';

export interface SortOrderSelectorProps {
  value: SortOrder;
  onChange: (order: SortOrder) => void;
  disabled?: boolean;
}

export const SortOrderSelector: React.FC<SortOrderSelectorProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const handleChange = (event: SelectChangeEvent<SortOrder>) => {
    onChange(event.target.value as SortOrder);
  };

  return (
    <FormControl sx={{ minWidth: 140 }} disabled={disabled}>
      <Select
        value={value || 'asc'}
        onChange={handleChange}
        size="small"
        renderValue={(selected) => {
          const normalized = typeof selected === 'string' ? selected.toLowerCase() : 'asc';
          return normalized === 'asc' ? 'Ascending' : 'Descending';
        }}
      >
        <MenuItem value="asc">
          <ArrowUpward fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
          Ascending
        </MenuItem>
        <MenuItem value="desc">
          <ArrowDownward fontSize="small" sx={{ mr: 1, verticalAlign: 'middle' }} />
          Descending
        </MenuItem>
      </Select>
    </FormControl>
  );
};
